"use client"
import {
  useModal
} from "./chunk-64A25YOZ.mjs";

// src/modal-header.tsx
import { forwardRef, ui } from "@yamada-ui/core";
import { cx, mergeRefs } from "@yamada-ui/utils";
import { jsx } from "react/jsx-runtime";
var ModalHeader = forwardRef(
  ({ className, __css, ...rest }, ref) => {
    const { headerRef, styles } = useModal();
    const css = {
      alignItems: "center",
      display: "flex",
      justifyContent: "flex-start",
      ...__css ? __css : styles.header
    };
    return /* @__PURE__ */ jsx(
      ui.header,
      {
        ref: mergeRefs(headerRef, ref),
        className: cx("ui-modal__header", className),
        __css: css,
        ...rest
      }
    );
  }
);
ModalHeader.displayName = "ModalHeader";
ModalHeader.__ui__ = "ModalHeader";

export {
  ModalHeader
};
//# sourceMappingURL=chunk-A64FIX7X.mjs.map